<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-row justify="center">
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="name"
          :counter="30"
          :rules="nameRules"
          label="Ваше имя"
          prepend-inner-icon="mdi-account-circle"
          outlined
          dense
          required
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="phone"
          :rules="phoneRules"
          label="Номер телефона"
          prepend-inner-icon="mdi-phone"
          outlined
          dense
          required
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="6" sm="4">
        <v-select
          v-model="select1"
          :items="items1"
          :rules="[v => !!v || 'Поле Диаметр обязательно для заполнения']"
          label="Диаметр"
          outlined
          dense
          required
        ></v-select>
      </v-col>
      <v-col cols="6" sm="4">
        <v-select
          v-model="select2"
          :items="items2"
          :rules="[v => !!v || 'Поле PCD профиля обязательно для заполнения']"
          label="PCD"
          outlined
          dense
          required
        ></v-select>
      </v-col>
      <v-col cols="6" sm="4">
        <v-select
          v-model="select3"
          :items="items3"
          :rules="[v => !!v || 'Поле Вылет(ET) обязательно для заполнения']"
          label="Вылет (ET)"
          outlined
          dense
          required
        ></v-select>
      </v-col>
      <v-col cols="6" sm="6">
        <v-select
          v-model="select4"
          :items="items4"
          :rules="[v => !!v || 'Поле Ступица(Dia) обязательно для заполнения']"
          label="Ступица(Dia)"
          outlined
          dense
          required
        ></v-select>
      </v-col>
      <v-col cols="12" sm="6">
        <v-select
          v-model="select5"
          :items="items5"
          :rules="[v => !!v || 'Поле Тип обязательно для заполнения']"
          label="Тип"
          outlined
          dense
          required
        ></v-select>
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col class="py-0" cols="12">
        <v-textarea
          v-model="text"
          outlined
          :counter="555"
          :rules="textRules"
          name="input-text"
          label="Комментарии к заказу"
        ></v-textarea>
      </v-col>
    </v-row>

    <v-row align="center" justify="center">
      <v-checkbox
        class="px-2"
        color="success"
        v-model="checkbox"
        :rules="[v => !!v || 'Отметить обязательно!']"
        label="Согласен на обработку своих персональных данных"
        required
      />
    </v-row>

    <v-row justify="center" align="center">
      <v-btn
        :disabled="!valid"
        color="success"
        class="mr-4 mb-2"
        @click="validate"
        :loading="loading"
        outlined
        text
      >
        Подобрать
      </v-btn>
      <v-btn
        class="mr-4 mb-2"
        color="error"
        @click="reset"
        :loading="loading"
        outlined
        text
      >
        Сбросить
      </v-btn>
    </v-row>
  </v-form>
</template>

<script>
import jsonItems1 from "@/assets/json/disksForm/items1.json";
import jsonItems2 from "@/assets/json/disksForm/items2.json";
import jsonItems3 from "@/assets/json/disksForm/items3.json";
import jsonItems4 from "@/assets/json/disksForm/items4.json";
import jsonItems5 from "@/assets/json/disksForm/items5.json";
export default {
  name: "FormDisks",
  data: () => ({
    loading: false,
    valid: true,
    name: "",
    nameRules: [
      v => !!v || "Введите Ваше имя",
      v =>
        (v && v.length <= 30) ||
        "Пожалуйста представьтесь не больше 30 символов"
    ],
    phone: "+7",
    phoneRules: [
      v => !!v || "Номер телефона обязательно для заполнения",
      v =>
        /^\+7\d{10}$/.test(v) ||
        "Введите Ваш номер в следующем формате +79999999999"
    ],
    text: "",
    textRules: [
      v =>
        (v && v.length <= 555) ||
        "Пожалуйста сократите Ваше сообщение до 555 символов"
    ],
    select1: null,
    select2: null,
    select3: null,
    select4: null,
    select5: null,
    items1: jsonItems1,
    items2: jsonItems2,
    items3: jsonItems3,
    items4: jsonItems4,
    items5: jsonItems5,
    checkbox: false
  }),
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        try {
          this.loading = true;
          const emailMessage = {
            name: this.name,
            phone: this.phone,
            text: `Пользователь отправил запрос с сайта по выбору комплекта дисков по параметрам:
            Диаметр: ${this.select1}, PCD: ${this.select2}, Вылет(ET): ${this.select3}, Ступица(Dia): ${this.select4}, Тип: ${this.select5}.
            Комментарий к заказу: ${this.text}`
          };
          let formData = new FormData();
          formData.append("name", emailMessage.name);
          formData.append("phone", emailMessage.phone);
          formData.append("text", emailMessage.text);
          this.$axios
            .post("https://fivetu-backend.herokuapp.com/emaildisks", formData)
            .then(response => {
              this.loading = false;
              this.$refs.form.reset();
              this.$store.dispatch("setMessage", {
                type: "success",
                text: response.data
              });
            })
            .catch(err => {
              this.loading = false;
              this.$store.dispatch("setMessage", {
                type: "error",
                text: `Ошибка при отправки письма. ${err.message}`
              });
            });
        } catch (e) {
          this.loading = false;
        }
      }
    },
    reset() {
      this.$refs.form.reset();
    }
  }
};
</script>

<style scoped></style>
